module.exports = __webpack_public_path__ + "img/MO.5eff5ae7.png";